export const setDashboard = {
  beforeCreate() {
    this.$store.commit('sidebar/SET_DASHBOARD', false)
  },
  destroyed() {
    this.$store.commit('sidebar/SET_DASHBOARD', true)
  }
}
